import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _map from 'lodash/map';
import _split from 'lodash/split';
// Core components
import Paper from 'components/core/Paper';
import Typography from 'components/core/Typography';
// Custom
import { deviceDataShape, scenarioActionDataShape } from 'constants/PropTypesShapes';
import Callout from 'components/misc/Callout';
import ConditionInputItem from './ConditionInputItem';
import ActionRelayItem from './ActionRelayItem';
import TriggerInputItem from './TriggerInputItem';

const ActionItemElementItem = ({ action, device }) => {
  const relayActions = action.expression !== '' ? _split(action.expression, ';').sort() : null;
  const inputConditionObj = action.input_condition;
  let inputConditions;
  if (inputConditionObj) {
    inputConditions = _split(inputConditionObj.expression, ';');
  }
  const inputTriggerObj = action.input_trigger;
  let inputTriggers;
  if (inputTriggerObj) {
    inputTriggers = _split(inputTriggerObj.expression, ';');
  }

  // const delaySeconds = action.delay / 10;
  // const totalDelaySeconds = action.totalDelay / 10;
  const durationSeconds = action.duration / 10;

  return (
    <Paper className="p-2 mb-3">
      {relayActions && (
        <React.Fragment>
          <Typography type="subtitle" className="pb-2">
            <LocalizedMessage id="subtitle.actions" />
          </Typography>
          <div className="information-item-wrapper">
            {!!relayActions && _map(relayActions, (relayAction) => (
              <ActionRelayItem
                key={relayAction}
                relayAction={relayAction}
                device={device}
              />
            ))}
          </div>
        </React.Fragment>
      )}
      {inputTriggerObj && (
        <React.Fragment>
          <Typography type="subtitle" className="pt-3 pb-2">
            <LocalizedMessage id="subtitle.inputTriggers" />
          </Typography>
          <div className="pb-2">
            <Callout>
              <LocalizedMessage id="info.duration" values={{ duration: durationSeconds }} />
            </Callout>
          </div>
          <div className="information-item-wrapper">
            {!!inputTriggers && _map(inputTriggers, (inputTrigger) => (
              <TriggerInputItem
                key={inputTrigger}
                inputTrigger={inputTrigger}
                device={device}
              />
            ))}
          </div>
        </React.Fragment>
      )}
      {inputConditionObj && (
        <React.Fragment>
          <Typography type="subtitle" className="pt-3 pb-2">
            <LocalizedMessage id="subtitle.inputConditions" />
          </Typography>
          <div className="information-item-wrapper">
            {!!inputConditions && _map(inputConditions, (inputCondition) => (
              <ConditionInputItem
                key={inputCondition}
                inputCondition={inputCondition}
                device={device}
              />
            ))}
          </div>
        </React.Fragment>
      )}
    </Paper>
  );
};

ActionItemElementItem.propTypes = {
  action: scenarioActionDataShape.isRequired,
  device: deviceDataShape.isRequired,
};

module.exports = ActionItemElementItem;



// WEBPACK FOOTER //
// ./routes/app/routes/installations/assets/scenarios/ActionItemElementItem.js